import Vue from 'vue';
import iView from 'iview';
import Router from 'vue-router';
import routers from './routers';
Vue.use(Router);
// 路由配置
var RouterConfig = {
    routes: routers
};
var router = new Router(RouterConfig);
router.beforeEach(function (to, from, next) {
    iView.LoadingBar.start();
    next();
});
router.afterEach(function (to) {
    iView.LoadingBar.finish();
    var el = document.getElementById('scrollId');
    if (el) {
        el.scrollTop = 0;
    }
    window.scrollTo(0, 0);
});
export default router;



//////////////////
// WEBPACK FOOTER
// ./src/router/index.ts
// module id = null
// module chunks = 